import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AddEditComponent } from '@shared/components/drdp-tables/add-edit/add-edit.component';
import { AuthService } from '@core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { take, tap } from 'rxjs';
import { IUser } from '@core/interfaces/iuser';
import { UserService } from '@core/services/user.service';
import { ILoginResponse } from '@core/interfaces/ilogin-response';
import { LookupService } from '@core/services/lookup.service';
import { ITraining } from '@core/interfaces/itraining';
import { Trainings } from '@core/enums/trainings';
import { Permission } from '@core/enums/permissions';
import { PermissionService } from '@core/services/permission.service';

@Component({
    selector: 'drdp-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserProfileComponent implements OnInit {
  @ViewChild(AddEditComponent) table?: AddEditComponent;
  user?: ILoginResponse;
  userInfo? : IUser;
  trainings: ITraining[] = [];
  readonly noTrainingsId = Trainings.NoTrainingsCompleted;
  canEditAgencyData = false;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private lookup: LookupService,
    private permissionService: PermissionService,
    public modal: MatDialog
  ) {}

  get completedTrainings(): ITraining[] {
    const ids = this.userInfo?.trainingIds ?? [];
    return this.trainings.filter((t) => ids.includes(t.id));
  }

  ngOnInit(): void {
    this.canEditAgencyData = this.permissionService.checkPermission(Permission.EditUserProfileAgencyData);
    this.lookup.getTrainings().pipe(take(1)).subscribe((res: ITraining[]) => {
      this.trainings = res;
    });
    this.user = this.authService.getCurrentUser();
    this.userService.getUserById(this.user.userId).pipe(
      take(1),
      tap((res: IUser) => {
        this.userInfo = res;
      })
    ).subscribe();
  }
  
}
